<template>
    <div>
        <v-toolbar app color="black" dark>
            <span @click="gotoHome()" class="mr-0"><v-icon class="home" color="white">home</v-icon></span>

            <v-toolbar-title data-cy="titleBtn">
                <img class="menuLogo mt-2" src="../assets/images/logo_icron_2.0_bianco.png" style="height: 30px" />
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-layout v-if="isDesktopMode()" align-start row justify-center class="primaryColor darken-2 p-0 m-0"
                style="border-radius: 10px 10px 10px 10px"><span class="white--text">
                    Live
                    results
                </span>
            </v-layout>
            <v-spacer></v-spacer>
            <span class="liveResults">Live Results</span>
        </v-toolbar>

        <v-layout align-start row wrap justify-center class="pa-0 black--text grey lighten-4 ">
            <v-flex v-if="isMobileMode()" flex xs12 sm12 md12 lg12 class="backColor white--text title mt-0 pa-1">
                <small>{{ raceInfo.name }}</small>
            </v-flex>
            <v-flex v-if="isMobileMode()" flex xs12 sm12 md12 lg12 class="grey lighten-2 black--text mt-0 pl-2">
                <small>{{ raceInfo.date }} - {{ raceInfo.location }}</small>
            </v-flex>
            <v-flex v-if="isMobileMode()" flex xs12 sm12 md12 lg12 class="black--text mt-3 pa-2">
                Live disponibili
            </v-flex>
            <v-flex flex xs12 sm12 md12 lg12 class="black--text title mt-2 ">
                <v-data-table :items="items" hide-actions hide-headers style="" class="mb-5">
                    <template slot="items" slot-scope="props">
                        <tr style="height:0px">
                        </tr>
                        <tr style="height:50px" :class="props.index % 2 == 0 ? 'grey lighten-3' : ''">
                            <td width="80%" @click="gotoReport(props.item)"><strong>{{ props.item }}</strong></td>
                            <td width="20%" @click="gotoReport(props.item)"> <span class="liveResults">Live</span></td>
                        </tr>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </div>
</template>


<script>
export default {
    name: 'LiveHome',

    data() {
        return {
            myInterval: undefined,
            items: [],

            raceInfo: {},
            report: {},
        };
    },

    mounted() {
        this.reportId = this.$route.params.reportId;

        clearInterval(this.myInterval);
        this.myInterval = setInterval(this.loadReports, 30000, this);
        this.loadReports()
    },


    beforeDestroy() {
        clearInterval(this.myInterval);
    },

    methods: {

        loadReports() {


            let _url = this.getApiURL() + "viewreport/" + this.reportId + ".list";
            if (window.location.hostname.indexOf("icron.it") != -1) {
                _url = this.getDataURL() + "getFile?idGara=icronium&fileName=" + this.reportId + ".list.json";;
            }

            _url = "https://www.icron.it/IcronLiveServices/services/live/getListCacheliveData"

            this.getCall(_url).then((response) => {

                this.items = Object.keys(response.mappaCachedLiveData)
                    .filter(k => k.startsWith(this.reportId))
                    .map(k => k.substring(this.reportId.length+1));


                this.raceInfo = {}

            }).catch(e => {
                this.busyChannel = false
            });
        },

        gotoReport(item) {
            let path = '/icronium/'+ this.reportId + "/" + item;
            this.$router.push(path)
        },

        gotoHome() {
            if (window.location.hostname.indexOf("icron.it") == -1) {
                let path = '/'
                this.$router.push(path)
            } else {
                window.location = "https://www.icron.it/live/"
            }
        }

    }
}
</script>
<style scoped>
td {
    height: 15px !important;
}

table.v-table tbody td {
    font-weight: 400;
    _font-size: 16px;
}

.backColor {
    background-color: #0D3D58;
    color: white;
    text-align: center
}

.primaryColor {
    background-color: #006064;
    color: white
}


.liveResults {
    background-color: red;
    color: white;
    border: 2px solid lightgray;
    border-radius: 5px;
    padding: 3px;
    font-weight: bold;
}

.home {
    background-color: #006064;
    color: white;
    border: 2px solid lightgray;
    border-radius: 5px;
    padding: 3px;
    font-weight: bold;
}
</style>
